export default __webpack_public_path__ + "static/media/icon-dashboard.e35f4061.svg";